<template>
  <v-container pa-5>
    <loader v-if="loading"></loader>
     <v-container v-else>  
    <v-tabs v-model="active" color="blue-grey ligthen-4" dark slider-color="yellow">
      <v-tab v-for="n in content" :key="n" ripple>
        {{ n }}
      </v-tab>
      <v-tab-item key:1 >
        <v-card pa-3 >
          <v-flex xs12 v-if="texts[0]===undefined">
            <v-card class="mt-5" width="50%" style="margin:auto">
              <v-card-title class="headline">
                No Data Available
              </v-card-title>
            </v-card>
          </v-flex>

          <v-layout row wrap>
            <v-card width="100%" v-for="(text,i) in texts " :key="i">
              <v-layout column pa-3>
                <v-layout row>
                  <v-flex xs6 sm5 md4 pa-1>
                    <h2> interestPoint: {{text.interestPoint}} - {{text.infoTTitle}} </h2>
                    <!-- <h4>id:{{text.infoTID}} </h4> -->
                    <h4>Lang:{{langs[text.infoTLang-1]}}</h4>
                    <h4>School Type:{{schools[text.infoSchType-1]}}</h4>
                   <h4> created By: {{text.createdBy}} </h4>
                   <h4> last Changed By : {{text.lastChangedBy}} </h4>
                  </v-flex>
                  <v-flex xs6 sm7 md8 class="text-xs-left">
                    <h4>Content</h4>
                    <b> Period: </b> {{text.infoTPeriod}}
                    <br> <b>Description: </b>  {{text.infoTText}}
                    <br> <b>Abbreviation: </b>  {{text.infoTAbbr}}
                    <br> <b>Source: </b> 
                    <i> {{text.infoTSource}} </i>
                  </v-flex>

                </v-layout>
                <v-flex xs12 offset-xs7 offset-md8 offset-lg9>
                   
                    <v-tooltip top>
                     <delete-text slot="activator" :text="text" ></delete-text>
                     <span>Delete Text</span>
                    </v-tooltip>
                    <v-tooltip top>
                    <edit-text slot="activator" :text="text" ></edit-text>
                    <span>Edit Text</span>
                    </v-tooltip>
                     <v-tooltip top>
                   <reform-text slot="activator" :text="text" :types="types" ></reform-text>
                    <span>Reform Text</span>
                    </v-tooltip>
                    <v-tooltip top>
                  <translate-text slot="activator" :text="text" :types="types"></translate-text>
                  <span>Translate Text</span>
                    </v-tooltip>
                </v-flex>
              </v-layout>
              <hr>
               
            </v-card>
  
          </v-layout>
           
        </v-card>
        
       <add-text id="addBtn"></add-text>
      </v-tab-item>
      <v-tab-item key:2>
        <v-card pa-3>
          <v-flex xs12 v-if="pics[0]===undefined">
            <v-card color="red" class="mt-5" width="50%" style="margin:auto">
              <v-card-title class="headline">
                No Data Available
              </v-card-title>
            </v-card>
          </v-flex>

          <v-layout row wrap>
            <v-card width="100%" v-for="(pic,i) in pics " :key="i">
              <v-layout column pa-3>
                <v-layout row>
                  <v-flex xs6 sm3 md3 pa-1>
                     <h2> interestPoint: {{pic.interestPoint}} - {{pic.infoPtitle}} </h2>
                    <!-- <h4>id:{{text.infoTID}} </h4> -->
                    <h4>Lang: {{langs[pic.infoPLang-1]}}</h4>
                    <h4>School Type: {{schools[pic.infoPSchType-1]}}</h4>
                   <h4> created By: {{pic.createdBy}} </h4>
                  <h4>  last Changed By : {{pic.lastChangedBy}} </h4>
                  </v-flex>
                  <v-flex pa-2 xs12 sm4 md4 class="text-xs-left">
                    <h4>Image</h4>
                    <v-card-media v-if="pic.infoPicture" style="border:solid;" :src="pic.infoPicture"
                      height="200px"></v-card-media>
                       <v-card-media v-if="!pic.infoPicture" style="border:solid;" src="http://www.alfavita.gr/sites/default/files/styles/imagearthron/public/0014-16-sx04.jpg"
                      height="200px"></v-card-media>
                  </v-flex>
                  <v-flex xs6 sm4 md4 class="text-xs-left">
                    <h4>Content</h4>
                    Abbreviation: {{pic.infoPAbbr}}
                    <br> Period: {{pic.infoPPeriod}}
                    <br> Source:
                    <i> {{pic.infoPSource}} </i>
                  </v-flex>

                </v-layout>
                <v-flex xs12 offset-xs7 offset-md8 offset-lg9>
               
                    <v-tooltip top>
                     <delete-pic slot="activator" :pic="pic" ></delete-pic>
                     <span>Delete Picture</span>
                    </v-tooltip>
                   <v-tooltip top>
                  <edit-pic slot="activator" :pic="pic" ></edit-pic>
                      <span>Edit Picture</span>
                    </v-tooltip>
                   <v-tooltip top>
                  <reform-pic slot="activator" :pic="pic" :types="typesPic" ></reform-pic>
                    <span>Reform Picture</span>
                    </v-tooltip>
                   <v-tooltip top>
                  <translate-pic slot="activator" :pic="pic" :types="typesPic" ></translate-pic>
                    <span>Translate Picture</span>
                    </v-tooltip>
                </v-flex>
              </v-layout>
              <hr>
            </v-card>

          </v-layout>
           
        </v-card>
       <create-pic id="addBtn"></create-pic>
      </v-tab-item>
      <v-tab-item key:3 v-if="!loading">
        <v-card>
          <v-card-text>Not Supported Yet</v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item key:4 v-if="!loading">
        <v-card>
          <v-card-text>Not Supported Yet</v-card-text>
        </v-card>
      </v-tab-item>

      <v-tab-item key:5 v-if="questions">

        <v-card pa-3>

          <v-flex xs12 v-if="questions[0]===undefined">
            <v-card color="red" class="mt-5" width="50%" style="margin:auto">
              <v-card-title class="headline">
                No Data Available
              </v-card-title>
            </v-card>
          </v-flex>

          <v-layout row wrap>
            <v-card width="100%" v-for="(que,i) in questions " :key="i">
              <v-layout column pa-3>
                <v-layout row>
                  <v-flex xs6 sm5 md4 pa-1>             
                    <h4>interestPoint: {{que.point}}</h4>
                    <!-- <h4>id:{{que.id}} </h4> -->
                    <h4>language: {{langs[que.language-1]}}</h4>
                    <h4>School: {{schools[que.school_type-1]}}</h4>
                   <h4> created By: {{que.createdBy}} </h4>
                   <h4> last Changed By : {{que.lastChangedBy}} </h4>
                  </v-flex>
                  <v-flex xs6 sm7 md8 class="text-xs-left">
                    <h4>Content</h4>
                    <h4>Question: {{que.question}}</h4>      
                         <v-list>
                            <template  v-for="(item, index) in que.options">
                              <v-list-tile :key="index">
                                <v-list-tile-content>
                                  <v-layout row wrap>  
                                  <v-list-tile-title  >{{index+1}} : {{item}}  <v-icon color="green" v-if="que.correct===index+1">check_circle</v-icon></v-list-tile-title>                                   
                                  </v-layout>
                                </v-list-tile-content>
                              </v-list-tile>
                           </template>
                        </v-list>       
                  </v-flex>
                </v-layout>
                <v-flex xs12 offset-xs7 offset-md8 offset-lg9>

                    <v-tooltip top>
                     <delete-que slot="activator" :que="que" ></delete-que>
                     <span>Delete Question</span>
                    </v-tooltip>

                    <v-tooltip top>               
                   <edit-que slot="activator" :que="que" ></edit-que>
                    <span>Edit Question</span>
                    </v-tooltip>
                   <v-tooltip top>
                   <reform-que slot="activator" :que="que" :types="typesQue" ></reform-que>
                             <span>Reform Question</span>
                    </v-tooltip>
                   <v-tooltip top>
                  <translate-que slot="activator" :que="que" :types="typesQue"></translate-que>  
                  <span>Translate Question</span>
                    </v-tooltip>
                </v-flex>
              </v-layout>
              <hr>               
            </v-card>  
          </v-layout> 

        </v-card>
       <create-que id="addBtn"></create-que>
      </v-tab-item>

    </v-tabs>

</v-container>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      fab: false,
      content: ["Texts", "Pictures", "Audio", "Video", "Questions"],
      langs: ["English", "Greek"],
      schools: ["Γενικής Παιδείας", "Ειδικής Παιδείας"],
      active: null,
      text:
        "abore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
    };
  },
  computed: {
    types() {
      var type = [];
      if (this.texts !== undefined) {
        for (let index = 0; index < this.texts.length; index++) {
          type.push({
            point: this.texts[index].interestPoint,
            id: this.texts[index].infoTID,
            lang: this.texts[index].infoTLang,
            sch: this.texts[index].infoSchType
          });
        }
        return type;
      }
    },
    typesPic() {
      var type = [];
      if (this.pics !== undefined) {
        for (let index = 0; index < this.pics.length; index++) {
          type.push({
            point: this.pics[index].interestPoint,
            id: this.pics[index].infoPID,
            lang: this.pics[index].infoPLang,
            sch: this.pics[index].infoPSchType
          });
        }
        return type;
      }
    },
    typesQue() {
      var type = [];
      if (this.questions !== undefined) {
        for (let index = 0; index < this.questions.length; index++) {
          type.push({
            point: this.questions[index].point,
            id: this.questions[index].id,
            lang: this.questions[index].language,
            sch: this.questions[index].school_type
          });
        }
        return type;
      }
    },
    maxTextId() {
      return this.$store.getters.maxTextId;
    },
    pics() {
      return this.$store.getters.pointPics;
    },
    texts() {
      return this.$store.getters.pointTexts;
    },
    questions() {
      return this.$store.getters.pointQuestions;
    },
    loading() {
      return this.$store.getters.loading;
    },

    activeFab() {
      switch (this.tabs) {
        case "one":
          return {
            class: "purple",
            icon: "account_circle"
          };
        case "two":
          return {
            class: "red",
            icon: "edit"
          };
        case "three":
          return {
            class: "green",
            icon: "keyboard_arrow_up"
          };
        default:
          return {};
      }
    }
  },
  destroyed: function() {
    this.$store.dispatch("clearData");
  },
  mounted: function() {
    this.$store.dispatch("loadSpotContent", Number(this.$route.params.id));
  },
  methods: {
    edit() {},
    deleteText(text) {
      this.$store.dispatch("deleteText", text);
    }
  }
};
</script>
<style scopped>
#addBtn {
  position: fixed;
  bottom: 5%;
  right: 1%;
}
</style>



// WEBPACK FOOTER //
// src/components/spotContent.vue